import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FeatherIcon } from "component/shared/feather-icon";
import { SearchAgentConversationDay } from "model/search-agent-profile";
import { AiSessionIds } from "../ai-session-ids";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	/** Newest first — ordered by getSearchAgentConversationDaysForLead. */
	conversationDays: SearchAgentConversationDay[];
	/**
	 * Opens a day's transcript. The design gives each row a chevron but does not define
	 * what it opens, so until that is settled the rows render without a click target.
	 */
	onSelect?: (conversationDay: SearchAgentConversationDay) => void;
	/** Replaces the card body with a load-failure message, so a failed fetch never reads as empty. */
	error?: boolean;
}

class Component extends React.Component<Props> {

	public render() {
		const { conversationDays, onSelect, error, classes = {} } = this.props;

		return (
			<div className={classes.card}>
				<Mui.Typography className={classes.title}>Conversation History</Mui.Typography>
				{error ? (
					<Mui.Typography className={classes.message}>
						Conversation history couldn't be loaded. Refresh the page to try again.
					</Mui.Typography>
				) : !conversationDays.length ? (
					<Mui.Typography className={classes.message}>
						No conversations yet. History builds as the lead chats with the Search Agent.
					</Mui.Typography>
				) : (
					conversationDays.map((conversationDay) => (
						<div
							key={conversationDay.date.format("YYYY-MM-DD")}
							className={classes.row}
							style={onSelect ? { cursor: "pointer" } : undefined}
							onClick={onSelect ? () => onSelect(conversationDay) : undefined}
						>
							<div className={classes.rowMain}>
								<div className={classes.rowHeader}>
									<span className={classes.date}>
										{conversationDay.date.format("MMM D, YYYY")}
									</span>
									<AiSessionIds aiSessionIds={conversationDay.aiSessionIds} />
								</div>
								{conversationDay.preview && (
									<div className={classes.preview}>{conversationDay.preview}</div>
								)}
							</div>
							<div className={classes.rowMeta}>
								<span className={classes.messageCount}>
									{conversationDay.messageCount}
									{conversationDay.messageCount === 1 ? " message" : " messages"}
								</span>
								<FeatherIcon className={classes.chevron}><Icons.ChevronRight /></FeatherIcon>
							</div>
						</div>
					))
				)}
			</div>
		);
	}
}

export const ConversationHistoryCard = withStyles(Component, styles);
